import { MemberCommitmentDocumentList } from '../../../components/Member';
import { usePageTitle } from '../../../hooks';

export function MemberCommitmentDocuments() {
  usePageTitle('member:commitmentDocuments.title');
  return <MemberCommitmentDocumentList />;
}
